<template>
  <div>
    <CIcon name="cipCircleLoader" class="text-primary d-block mx-auto m-5" size="custom-size" :height="35" />
  </div>
</template>
<script>
export default {
  name: "Spinner",
}
</script>